jQuery(document).ready(function ($) {

	$('.oab-previous-editions-intro__text').on('click', function () {
		$(this).text($(this).text() == 'Voir plus' ? 'Montrer moins' : 'Voir plus');
		if ($(this).text() == 'Montrer moins') {
			$('.oab-previous-editions-intro__icon_down').hide();
			$('.oab-previous-editions-intro__icon_up').show();
			$('.oab-previous-editions-intro__years-item.small').show();
		} else {
			$('.oab-previous-editions-intro__icon_down').show();
			$('.oab-previous-editions-intro__icon_up').hide();
			$('.oab-previous-editions-intro__years-item.small').hide();
		}
	});


	if ($('.oab-previous-editions-intro__text').text() == 'Montrer moins') {
		$('.oab-previous-editions-intro__icon_down').hide();
		$('.oab-previous-editions-intro__icon_up').show();
		$('.oab-previous-editions-intro__years-item.small').show();
	} else {
		$('.oab-previous-editions-intro__icon_down').show();
		$('.oab-previous-editions-intro__icon_up').hide();
		$('.oab-previous-editions-intro__years-item.small').hide();
	}


	let activeYear = $('.oab-previous-editions-intro__years .active a')
	$('.title-pink .year').text($(activeYear).text());



	$('.oab-previous-editions-intro__years-item a').on('click', function (event) {
		event.preventDefault();
		$('.breadcrumbs li:last-child a').text($(this).parent().attr('data-title'));

		window.history.pushState({}, '',$(location).attr('origin') + '/fr-fr/blog-et-ressources/evenements/' +$(this).parent().attr('data-slug'));
		$('.title-pink .year').text($(this).text());


		if ($(this).parent().hasClass('active')) {
			return;
		}

		$('.oab-previous-editions-intro__years-item').removeClass('active');
		$(this).parent().addClass('active');


		$(".oab-previous-editions-intro__loading").css('opacity', '1');

		let data = {
			'action': 'event',
			'id': $(this).parent().attr('data-id'),
		};

		$.post(oab_loc.ajax_url, data, function (response) {
			$(".oab-previous-editions-intro__loading").css('opacity', '0');
			let result = JSON.parse(JSON.stringify(response));
			let talkers = result.talkers;

			$('.event-nav').html(result.eventNav);
			$('.oab-previous-editions-navy-box-with-background-image__title').text(result.name);
			$('.oab-previous-editions-navy-box-with-background-image__location').text(result.location);
			$('.oab-previous-editions-navy-box-with-background-image__date').text(result.date);
			$('.oab-previous-editions-navy-box-with-background-image__description').text(result.description);

			$('.oab-talks-replay-grid__content-container').attr('data-event-title', result.name);
			$('.oab-talks-replay-grid__content-container').attr('data-event-url', result.url);


			$('.oab-talks-replay-grid__content-container').html('');


			$.each($(talkers), function (key, val) {
				let $talker = $($('.oab-talks-replay-grid__content-prototype').html());

				$talker.find('.oab-talks-replay-grid__img a').attr('href', val['post']);

				if (val['image_url']) {
					$talker.find('.oab-talks-replay-grid__img img').attr('src', val['image_url']);
					$talker.find('.oab-talks-replay-grid__img img').attr('alt', val['image_alt']);
					$talker.find('.oab-talks-replay-grid__img img').attr('title', val['image_title']);
				} else {
					$talker.find('.oab-talks-replay-grid__img img').remove();
				}

				$talker.find('.oab-talks-replay-grid__linkedin-icon a').attr('href', val['linkedin']);

				$talker.find('.oab-talks-replay-grid__talker_name a').attr('href', val['post']);
				$talker.find('.oab-talks-replay-grid__talker_position a').attr('href', val['post']);
				$talker.find('.oab-talks-replay-grid__talker_name a').text(val['name']);
				$talker.find('.oab-talks-replay-grid__talker_position a').text(val['position']);
				$talker.find('.oab-talks-replay-grid__logo a').attr('href', val['post']);
				if(val['logo_url']) {
					$talker.find('.oab-talks-replay-grid__logo img').attr('src', val['logo_url']);
					$talker.find('.oab-talks-replay-grid__logo img').attr('alt', val['logo_alt']);
					$talker.find('.oab-talks-replay-grid__logo img').attr('title', val['logo_title']);
				} else {
					$talker.find('.oab-talks-replay-grid__logo img').remove();
				}
				$talker.find('.oab-talks-replay-grid__text a').attr('href', val['post']);
				$talker.find('.oab-talks-replay-grid__text a').text(val['speech_title']);
			    $talker.find('.oab-talks-replay-grid__btn a').attr('href', val['post']);

				$('.oab-talks-replay-grid__content-container').append($talker);
			});
		});
	});
});
